/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React, {useEffect} from 'react';
import AppStatic from "../../utils/AppStatic";
import {
    PiChatCircleDotsThin,
    PiPaperPlaneTiltThin,
    PiUsersThreeThin
} from "react-icons/pi";
import {useGetStatisticsQuery} from "../../services/statisticsApi";

const AppStatistics = () => {
    const [invitesNo, setInvitesNo] = React.useState(0);
    const [accountsNo, setAccountsNo] = React.useState(0);
    const [ivyConversationsNo, setIvyConversationsNo] = React.useState(0);
    const {
        data: statistics,
        isSuccess
    } = useGetStatisticsQuery();

    useEffect(() => {
        if (isSuccess && Array.isArray(statistics)) {
            const invitations = statistics.find(stat => stat.type === "invitations");
            const users = statistics.find(stat => stat.type === "users");
            const ivyChats = statistics.find(stat => stat.type === "ivyChats");

            setInvitesNo(invitations?.statisticValue || 0);
            setAccountsNo(users?.statisticValue || 0);
            setIvyConversationsNo(ivyChats?.statisticValue || 0);
        }
    }, [isSuccess, statistics]);

    return (
        <>
            {(isSuccess && statistics) && (
                <div className="relative mt-0 md:mt-8">
                    <div
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full items-center justify-center">
                        <div className="text-center pb-5">
                            <PiPaperPlaneTiltThin className="text-6xl m-auto"/>
                            <p className="mt-2 uppercase text-3xl font-bold tracking-widest">
                                + {invitesNo.toLocaleString('ro-RO')}
                            </p>
                            <p className="text-mono-1000 text-base">
                                {AppStatic.distributedInvitesText.ro.translation}
                            </p>
                        </div>
                        <div className="text-center pb-5">
                            <PiUsersThreeThin className="text-6xl m-auto "/>
                            <p className="mt-2 uppercase text-3xl font-bold tracking-widest">
                                + {accountsNo.toLocaleString('ro-RO')}
                            </p>
                            <p className="text-mono-1000 text-base">
                                {AppStatic.activeAccounts.ro.translation}
                            </p>
                        </div>
                        <div className="text-center pb-5">
                            <PiChatCircleDotsThin className="text-6xl m-auto"/>
                            <p className="mt-2 uppercase text-3xl font-bold tracking-widest">
                                + {ivyConversationsNo.toLocaleString('ro-RO')}
                            </p>
                            <p className="text-mono-1000 text-base">
                                {AppStatic.ivyConversationsText.ro.translation}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default AppStatistics;
